import $ from '@ali/tarzan-zepto';
import tpl from './tpl.html';
import './style.scss';

const LOG_C = 'buttons';
let app = null;

/**
 * 根据不同action类型，做不同交互
 * @param  {[type]} action [description]
 * @param  {[type]} params [description]
 * @param  {[type]} $node  [description]
 * @param  {[type]} $btn  [description]
 * @return {[type]}        [description]
 */
function actionRoute(action, params, $node, $btn) {
  if (action === 'send') {
    // 不计历史消息，不展示
    if (params.header) {
      let show = true;
      if (params.header.msglog === 2) {
        show = false;
      }
      app.view.footer.submit({
        q: params.content,
        header: params.header,
      }, 'text', show);
    } else {
      app.view.footer.submit(params.content);
    }
    // 发送完，删除
    $node.remove();
  } else if (action === 'photo' || action === 'camera') {
    app.bridge.photo({
      type: action,
      bizCode: 'alxm',
    }).then((res) => {
      const url = res.url;
      app.appendMessage({
        type: 'image',
        body: {
          side: 'right',
          text: `<img src="${url}" >`,
        },
      });
      app.view.footer.submit(url, 'image', false, true);
      // 选择完，删除
      $node.remove();
    }, (err) => {
      if (err === 'NO_PERMISSION') {
        app.bridge.toast(`请开启${action === 'camera' ? '拍照' : '访问相册'}权限哦`);
      }
    });
  } else if (action === 'writewish') {
    $btn.addClass('disabled');
    $btn.siblings().addClass('disabled');
    // TODO-唤起写祝福的组件
  } else if (action === 'share') {
    app.bridge.share(params);
  } else if (action === 'selectOrder') {
    app.orderList.show({
      source: 'buttons',
    });
  }
}

function onClickBtn(ev, $node) {
  const $target = $(ev.currentTarget);
  const action = $target.attr('data-action');
  const params = JSON.parse($target.attr('data-params'));
  if ($target.hasClass('disabled')) {
    return;
  }
  actionRoute(action, params, $node, $target);
  app.log.send({
    c: LOG_C,
    d: 'btn',
    ext: {
      action,
    },
  });
}

function bindEvents($node) {
  $node.find('.J_Btn').on('tap', ev => onClickBtn(ev, $node));
}

export default function buttons(data) {
  // console.log(data);
  app = this;
  data.list.forEach((t) => {
    t.param = JSON.stringify(t.params);
    // 在历史消息里，并且permanent为false，则不展示
    if (data.__history__ && !t.permanent) {
      t.show = false;
    } else {
      t.show = true;
    }
  });
  const $node = $(tpl.render(data));

  bindEvents($node);

  return {
    // 插件返回的结果
    body: $node,
    // 插件调用ready后的回调
    callback: () => {
      //
    },
  };
}



// WEBPACK FOOTER //
// ./src/app/extension/buttons/index.js